import axios from 'axios'
import {Config} from '../utils/Config'
import {attachAuthorizationHeader} from './setupAxiosAuth'

// Create axios instance for admin API calls
const adminClient = axios.create({
  responseType: 'json',
  baseURL: Config.ADMIN_BASE_URL,
  transformResponse: response => response,
})

// Default headers and settings
adminClient.defaults.headers.post['Content-Type'] = 'application/json'
adminClient.defaults.headers.post.Accept = 'application/json'
adminClient.defaults.headers.pragma = 'no-cache'
adminClient.defaults.withCredentials = false
adminClient.defaults.timeout = 240000

adminClient.interceptors.request.use(attachAuthorizationHeader)

// Admin request wrapper with error handling
const adminRequest = options => {
  return adminClient(options)
    .then(response => {
      if (typeof response.data === 'string') {
        try {
          return JSON.parse(response.data)
        } catch {
          return response.data
        }
      }
      return response.data
    })
    .catch(error => {
      return Promise.reject(
        error.response
          ? typeof error.response.data === 'string'
            ? JSON.parse(error.response.data)
            : error.response.data
          : {message: error.message, success: false}
      )
    })
}

export default adminRequest
